module.exports = __webpack_public_path__ + "static/videos/etch_004.0a4da78.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/etching/etch_004.mp4
// module id = 466
// module chunks = 1